import store from "redux/store"
import {reset} from "redux/graphSlice"

export let actionLog = []

export function resetActions() {
	store.dispatch(reset())
	actionLog = []
}

export default function loggingMiddleware(storeAPI) {
	return function wrapDispatch(next) {
		return function log(action) {
			switch (action.type) {
				case "graph/excludeEffect":
				case "graph/includeEffect":
				case "graph/includeDrug":
				case "graph/excludeDrug":
				case "graph/drugUp":
				case "graph/drugDown":
				case "graph/sort":
					actionLog.push({
						type: action.type,
						timestamp: Date.now(),
						payload: action.payload
					})
					break
				default:
					break
			}
			return next(action)
		}
	}
}
